import React from "react";
import { Spinner } from "react-bootstrap";
import "../assets/css/styles.css";

const Loading: React.FC = () => {
  return (
    <div className="loading-overlay">
      <Spinner animation="border" variant="info" role="status" />
    </div>
  );
};

export default Loading;
